<template>
  <van-popup v-model="popupVisible" position="bottom" @closed="$emit('close')" style="max-height: 70%;min-height: 50%">
    <div class="search-vote w-full h-full">
      <div class="text-center pb-3">
        <span>筛选</span>
      </div>
      <div class="p-4 bg-white">
        <div v-for="item in list" :key="item.q_id" class="mb-3 last:mb-0">
          <vote-search :question="item" />
        </div>
        <div class="mt-3">
          <van-button block type="primary" size="small" @click="onConfirm">确定</van-button>
        </div>
      </div>
    </div>

  </van-popup>
</template>

<script>
import VoteSearch from './search/VoteSearch.vue'

export default {
  name: 'SearchVotePopup',
  components: { VoteSearch },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      popupVisible: false
    }
  },
  mounted() {
    this.popupVisible = true
  },
  methods: {
    onConfirm() {
      this.$emit('confirm', this.list)
    }
  }
}
</script>

<style scoped lang="scss">
.search-vote {
  background-color: #F5F5F5;
  padding: 12px;
  box-sizing:border-box;
}
</style>